import { Text, View } from 'react-native'
import { Link, useNavigation } from 'expo-router'
import Button from '@ui/buttons/Button'
import Icon from '@ui/elements/Icon/Icon'
import { useTranslation } from 'react-i18next'

const useResetNav = () => {
  const { reset } = useNavigation<any>()

  return (name: string) => {
    reset({
      index: 0,
      routes: [
        {
          name,
        },
      ],
    })
  }
}

export default function LoginPage() {
  const { t } = useTranslation('ui')
  const resetNav = useResetNav()
  return (
    <View className="flex-1 items-center  p-6">
      <View className="flex-1 items-center justify-center gap-4">
        <Icon name="check" />
        <Text className="text-4xl font-bold">{t('ui:login')}</Text>
        <Button label={t('ui:signin')} onPress={() => resetNav('/')} />
        <Link href="/customer/home" replace asChild>
          <Button label={t('ui:back')} />
        </Link>
      </View>
    </View>
  )
}
